import { useState, useEffect } from "react";
import {
  getBankAccountsLinked,
  getBankAccountsTaxRefundDepositDestination,
  getBankAccountVerificationTaxRefundDepositDestinationStatus,
  getUserProfile,
} from "store/api/apiSlice";

const useBankAccountForTaxFilingDisplay = () => {
  const { data: userProfile, isLoading: isLoadingUserProfile } =
    getUserProfile();

  // Only fetch refund deposit account if user is eligible for tax refund advance and account is ready
  const [hasRefundDepositAccount, setHasRefundDepositAccount] = useState(false);
  const {
    data: refundDepositAccountStatus,
    isLoading: isLoadingDepositAccountStatus,
  } = getBankAccountVerificationTaxRefundDepositDestinationStatus({
    pollingInterval: !hasRefundDepositAccount ? 5000 : undefined,
    skip: !userProfile?.incomeTaxRefundAdvanceAllowed,
  });
  const {
    data: refundDepositAccount,
    isLoading: isLoadingRefundDepositAccount,
  } = getBankAccountsTaxRefundDepositDestination({
    skip: !hasRefundDepositAccount,
  });
  // Otherwise get linked bank account
  const { data: linkedBankAccount, isLoading: isLoadingLinkedBankAccount } =
    getBankAccountsLinked({
      skip: userProfile?.incomeTaxRefundAdvanceAllowed,
    });

  useEffect(() => {
    setHasRefundDepositAccount(refundDepositAccountStatus?.currentStatus);
  }, [refundDepositAccountStatus]);

  const isLoading =
    isLoadingDepositAccountStatus ||
    isLoadingRefundDepositAccount ||
    isLoadingLinkedBankAccount ||
    isLoadingUserProfile;
  const bankAccount = userProfile?.incomeTaxRefundAdvanceAllowed
    ? refundDepositAccount
    : linkedBankAccount;

  return { isLoading, hasRefundDepositAccount, bankAccount };
};

export default useBankAccountForTaxFilingDisplay;
